<div id="bars1">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
</div>
